import { z } from 'zod/v4';

import { normalizeTextWidgetArgs } from './text-widget-args.normalization';
import { partialTextWidgetDataSchema, textContentSchema } from './partial-text-widget-data.schema';

/**
 * `content` is the one field promoted from optional to REQUIRED on create — everything else on
 * `partialTextWidgetDataSchema` has a sane factory default, but a text widget with no text is an
 * invisible gap the user then has to hunt for and delete. Declared via `.extend()` on the shared
 * partial rather than a hand-copied field list, so the two tools' surfaces can't drift.
 */
const createTextWidgetDataSchema = partialTextWidgetDataSchema.extend({ content: textContentSchema });

const createTextWidgetObjectSchema = z.object({
    columnId: z.string().describe('Id of the column to create the text widget in.'),
    index: z
        .number()
        .int()
        .min(0)
        .optional()
        .describe("Position within the column's widget list (0-based). Omit to append at the end."),
    data: createTextWidgetDataSchema.describe(
        'Text widget data. Only content is required; alignment, width, visibility and animation all fall ' +
            'back to sane defaults.'
    ),
});

export const createTextWidgetArgsSchema = z.preprocess(normalizeTextWidgetArgs, createTextWidgetObjectSchema);
